module.exports = __webpack_public_path__ + "img/message.b0f6d9c4.svg";